import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_SET_XCARD,

  ACTION_LOAD_XCARD_INIT__REQUEST,
  ACTION_LOAD_XCARD_INIT__SUCCESS,
  ACTION_LOAD_XCARD_INIT__FAIL,

  ACTION_ORDER_XCARD__REQUEST,
  ACTION_ORDER_XCARD__SUCCESS,
  ACTION_ORDER_XCARD__FAIL,

  ACTION_RECHECK_XCARD_STATUS__REQUEST,
  ACTION_RECHECK_XCARD_STATUS__SUCCESS,
  ACTION_RECHECK_XCARD_STATUS__FAIL,
} from '../actionTypes';


export const actionSetXCard = card => ({
  type: ACTION_SET_XCARD,
  payload: { card },
});

const actionLoadXCardInitSuccess = formSettings => ({
  type: ACTION_LOAD_XCARD_INIT__SUCCESS,
  payload: { formSettings },
});

const actionLoadXCardInitFail = error => ({
  type: ACTION_LOAD_XCARD_INIT__FAIL,
  payload: { error },
});

export const actionLoadXCardInitRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_XCARD_INIT__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/xcard/init'
    ).then(
      result => {
        dispatch(actionLoadXCardInitSuccess(result));
      },
      error => {
        dispatch(actionLoadXCardInitFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

const actionOrderXCardSuccess = () => ({
  type: ACTION_ORDER_XCARD__SUCCESS,
});

const actionOrderXCardFail = error => ({
  type: ACTION_ORDER_XCARD__FAIL,
  payload: { error },
});

export const actionOrderXCardRequest = xCard => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_ORDER_XCARD__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/xcard/order',
      { data: xCard }
    ).then(
      card => {
        dispatch(actionSetXCard(card));
        dispatch(actionOrderXCardSuccess());
      },
      error => {
        dispatch(actionOrderXCardFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

const actionRecheckXCardStatusSuccess = () => ({
  type: ACTION_RECHECK_XCARD_STATUS__SUCCESS,
});

const actionRecheckXCardStatusFail = error => ({
  type: ACTION_RECHECK_XCARD_STATUS__FAIL,
  payload: { error },
});

export const actionRecheckXCardStatusRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_RECHECK_XCARD_STATUS__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/xcard/recheck_status'
    ).then(
      card => {
        dispatch(actionSetXCard(card));
        dispatch(actionRecheckXCardStatusSuccess());
      },
      error => {
        dispatch(actionRecheckXCardStatusFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
